import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { Observable, catchError, from, map, of, tap } from "rxjs";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { Share, ShareResult } from "@capacitor/share";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DialogAiball } from "@app/presentation/components/dialog-aiball/dialog-aiball.component";
import { DialogShareInWebDesktopComponent } from "@app/presentation/components/dialog-share-in-web-desktop/dialog-share-in-web-desktop.component";

@Injectable({ providedIn: "root" })
export class ShareMessageDesktopWeb {
  constructor(private modalService: NgbModal) {}

  execute(message: string, url: string): Observable<string> {
    let shareData = {
      title: "",
      text: message,
      url: url,
    };
    //In the future here we'll
    return of("").pipe(
      tap(() => this.#openShareDialog(message, url)),
      catchError((err) => of("error not catched"))
    );
  }

  #openShareDialog(message: string, url: string) {
    const ref = this.modalService.open(DialogShareInWebDesktopComponent, {
      centered: true,
    });
    ref.componentInstance.data = {
      message: message,
      url: url,
    };
  }
}
